export const MAX_SEARCH_OPTIONS = 5;
